/**
 * Indicates the type of relative value measurement being specified.
 * tag: 2530
 * @readonly
 * @enum {number} (int)
 */
export enum RelativeValueType {
  ASWSpread = 1,
  OIS = 2,
  ZSpread = 3,
  DiscountMargin = 4,
  ISpread = 5,
  OAS = 6,
  GSpread = 7,
  CDSBasis = 8,
  CDSInterpolatedBasis = 9,
  DV01 = 10,
  PV01 = 11,
  CS01 = 12,
}
